//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue       from 'vue';
import Component from 'vue-class-component';
import MissingNo from '@/components/MissingNo';

@Component({
	metaInfo   : {
		title : 'Not Found',
	},
	components : {
		MissingNo,
	},
})
export default class NotFound extends Vue {}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<section class="g--fullscreen g--flowdown">
	<div class="s--navbar-gap" />

	<MissingNo class="g--stretch">
		<slot>Page Not Found</slot>
	</MissingNo>

	<div class="s--footer-gap" />
</section>
</template>
